<div class="container-fluid">
  <div class="row">
    @if (userAccountRole === 'CLIENT_ADMIN') {
      <app-display-counts-widget
        [widgetPanelCounts]="widgetPanelCounts"
        [title]="widgetPanelCounts.title"
      ></app-display-counts-widget>
    }

    @if (userAccountRole === 'CLIENT_VENDOR_AND_SITES_MANAGER') {
      <app-title-content-widget [title]="'Contracts'">
        <ng-template #titleContentPanel>
          <div
            class="inner-panel cursor-select"
            (click)="navigateToContractsPage()"
          >
            <div class="row h-100 justify-content-center align-items-center">
              <div class="col-auto">
                <i class="lh-0 bi bi-cash-coin fs-220"></i>
              </div>
            </div>
          </div>
        </ng-template>
      </app-title-content-widget>
    }
  </div>
</div>
